import { Wrench } from "lucide-react";
import { RepairCarousel } from "./RepairCarousel";
import { AccreditationBadges } from "./AccreditationBadges";
import { repairImages } from "../data/media";

const services = [
  "Accident repairs",
  "Bodywork & panel repairs",
  "Dents & body damage",
  "Private vehicle repairs",
  "Full & partial resprays",
  "Insurance claim repairs",
];

export const BodyshopSection = ({ testId = "bodyshop-section", repairGallery = repairImages }) => (
  <section className="bg-[#0e0d0c]" data-testid={testId}>
    <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 sm:py-24">
      <div className="grid items-start gap-10 lg:grid-cols-2 lg:gap-16">
        <div>
          <p className="section-label">Our Own Garage &amp; Bodyshop</p>
          <h2
            data-testid={`${testId}-heading`}
            className="font-display mt-4 text-2xl leading-snug text-[#f2ede3] sm:text-[2rem]"
          >
            Accident Repairs &amp; Bodywork, Done Properly
          </h2>
          <p className="mt-5 text-sm leading-relaxed text-[#a09a8c] sm:text-base">
            Beyond claims support, EDT operates its own garage and bodyshop facilities —
            handling insurance claim repairs and private vehicle bodywork with the same
            attention to detail from start to finish.
          </p>
          <ul className="mt-8 grid gap-x-8 gap-y-4 sm:grid-cols-2">
            {services.map((s, i) => (
              <li
                key={s}
                data-testid={`${testId}-service-${i + 1}`}
                className="flex items-center gap-3 text-sm text-[#f2ede3]"
              >
                <Wrench size={15} className="shrink-0 text-[#c9a24b]" />
                {s}
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="section-label">Accredited &amp; Approved</p>
          <AccreditationBadges testId={`${testId}-accreditations`} />
        </div>
      </div>

      <div className="mt-14 sm:mt-16">
        <h3 className="font-display text-xl text-[#f2ede3] sm:text-2xl">
          Recent Repair Work
        </h3>
        <div className="mt-8">
          <RepairCarousel images={repairGallery} testId={`${testId}-repair-carousel`} />
        </div>
      </div>
    </div>
  </section>
);
